export const state = {
  alluser: [],
};
